import React, {useEffect, useState} from "react";
import {
    makeStyles,
    createMuiTheme,
    responsiveFontSizes,
    ThemeProvider,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";

let theme = createMuiTheme({
    palette: {
        background: {
            paper: "#101010",
        },
        type: "dark",
    },
});
theme = responsiveFontSizes(theme);

const useStyles = makeStyles((theme) => ({
    box: {
        minWidth: "90vw",
    },
    paper: {
        minWidth: "20vw",
        height: "max-content",
        padding: "10px",
    },
}));

const AllData = ({url}) => {
    const classes = useStyles();

    const [data, setData] = useState({});
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);

            try {
                const result = await fetch(url);
                const data = await result.json();
                setData(data);
            } catch (error) {
                setIsError(true);
            }

            setIsLoading(false);
        };
        fetchData();
    }, [url]);

    return (
        <ThemeProvider theme={theme}>
            <Grid container direction="column">
                <Box m={0} className={classes.box}>
                    {!isError && (
                        <Grid item container spacing={1} justify="flex-start">
                            <Grid item md={3} xs={12}>
                                <Paper className={classes.paper}>
                                    <Typography
                                        variant="h4"
                                        style={{color: "#fff"}}
                                    >
                                        Cases
                                    </Typography>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="h5">
                                            {data.cases}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Paper className={classes.paper}>
                                    <Typography
                                        variant="h4"
                                        style={{color: "#fff"}}
                                    >
                                        Cases Today
                                    </Typography>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="h5">
                                            {data.todayCases}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Paper className={classes.paper}>
                                    <Typography
                                        variant="h4"
                                        style={{color: "#fff"}}
                                    >
                                        Tests Conducted
                                    </Typography>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="h5">
                                            {data.tests}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Paper className={classes.paper}>
                                    <Typography
                                        variant="h4"
                                        style={{color: "#f44336"}}
                                    >
                                        Deaths
                                    </Typography>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="h5">
                                            {data.deaths}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Paper className={classes.paper}>
                                    <Typography
                                        variant="h4"
                                        style={{color: "#f44336"}}
                                    >
                                        Deaths today
                                    </Typography>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="h5">
                                            {data.todayDeaths}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Paper className={classes.paper}>
                                    <Typography
                                        variant="h4"
                                        style={{color: "#ffeb3b"}}
                                    >
                                        Active
                                    </Typography>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="h5">
                                            {data.active}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Paper className={classes.paper}>
                                    <Typography
                                        variant="h4"
                                        style={{color: "#76ff03"}}
                                    >
                                        Recovered
                                    </Typography>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="h5">
                                            {data.recovered}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>

                            <Grid item md={3} xs={12}>
                                <Paper className={classes.paper}>
                                    <Typography
                                        variant="h4"
                                        style={{color: "#ff1744"}}
                                    >
                                        Critical
                                    </Typography>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="h5">
                                            {data.critical}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className={classes.paper}>
                                    {isLoading && <CircularProgress />}
                                    {!isLoading && (
                                        <Typography variant="subtitle1">
                                            {`Last checked at ${
                                                data.updated
                                                    ? new Date(
                                                          data.updated
                                                      ).toTimeString()
                                                    : ""
                                            }`}
                                        </Typography>
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>
                    )}
                    {isError && (
                        <Grid item md={3} xs={12}>
                            <Paper className={classes.paper}>
                                <Typography
                                    variant="h4"
                                    style={{color: "#fff"}}
                                >
                                    Error Ocurred. Refesh or try later.
                                </Typography>
                            </Paper>
                        </Grid>
                    )}
                </Box>
            </Grid>
        </ThemeProvider>
    );
};

export default AllData;
